import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling } from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';
import { stackSpacing, stackStyling } from 'components/forms/new/formStyles';

const PlansDropdown = ({ darkMode, errors, plans, isLoadingPlans }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();
    const handleSelectChange = (selectedIds) => {
        const selectedPlans = plans.filter((plan) =>
            selectedIds.includes(plan.id),
        );
        updateFormData(FORM_FIELD_PATHS.PLANS, selectedPlans);
    };
    const hasError = !!errors?.plans;
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{
                    ...stackStyling(),
                    height: 'auto',
                    paddingBottom: '15px',
                }}
                height="auto">
                <FormLabel sx={formLabelStyling(darkMode)}>Plans</FormLabel>
                <Box flex={1} maxWidth="400px" height="auto">
                    <Field
                        component={DropDown}
                        isMulti={true}
                        id={FORM_FIELD_PATHS.PLANS}
                        name={FORM_FIELD_PATHS.PLANS}
                        data={plans}
                        isLoading={isLoadingPlans}
                        height="auto"
                        multiValue={
                            Array.isArray(formData[FORM_FIELD_PATHS.PLANS])
                                ? formData[FORM_FIELD_PATHS.PLANS].map(
                                      (plan) => plan.id,
                                  )
                                : []
                        }
                        shownValue="name"
                        handleSelectChange={handleSelectChange}
                        placeholder="Select plans"
                        width="100%"
                        darkMode={darkMode}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Type to add a plan for this company"
                        ariaLabel="plans-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};
export default PlansDropdown;
